module.exports = __webpack_public_path__ + "static/media/online.4702cbc5.png";